// extracted by mini-css-extract-plugin
module.exports =  {"root":"PHbM1pQELRzJ3JRPPAFx"};